import { Box, Button, Divider, Paper, Stack, TextField, Typography, FormControl, Select, MenuItem } from '@mui/material';
import { useState } from 'react';
import { toArrayBuffer, toXYZTilesURL } from '../../utils';
import { BP_COLOR } from '../../bp-theme';
import { useNotify } from '../../hooks';

export const LocationForm = ({ detectItem, openBackdrop, setItem, item }) => {
  const [position, setPosition] = useState({ lat: 0, long: 0 });
  const notify = useNotify();

  const handleChange = e => {
    const { value, name } = e.target;
    setPosition({ ...position, [name]: +value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const { lat, long } = position;
    if (lat !== 0 && long !== 0) {
      try {
        openBackdrop(true);
        const zoom = item === 'pool' ? 18 : 20;
        const url = toXYZTilesURL(lat, long, zoom);
        const res = await fetch(url);
        const resource = await toArrayBuffer(await res.blob());
        detectItem(item, resource);
      } catch (err) {
        notify(err.message, { type: 'error' });
      }
    }
  };

  const changeItem = e => {
    const { value } = e.target;
    setItem(value);
  };

  return (
    <Box sx={{ maxWidth: 400, textAlign: 'center', marginX: 'auto' }}>
      <Paper elevation={2} sx={{ py: 1, px: 3, m: 1 }}>
        <Typography variant='h5' color={BP_COLOR[10]} my={1}>
          Lancer la détection
        </Typography>
        <Divider />
        <FormControl fullWidth>
          <Select id='item-select' value={item} label='Item' variant='filled' onChange={changeItem}>
            <MenuItem value='pool'>Piscine</MenuItem>
            <MenuItem value='velux'>Velux</MenuItem>
          </Select>
        </FormControl>
        <h3>Coordonnées GPS</h3>
        <Box component='form' autoComplete='off' onSubmit={handleSubmit} noValidate sx={{ my: 2 }}>
          <Stack spacing={3}>
            <TextField
              label='Latitude'
              type='number'
              variant='filled'
              name='lat'
              onChange={handleChange}
              value={position.lat || ''}
              sx={{ color: BP_COLOR[10] }}
              autoFocus
            />
            <TextField
              label='Longitude'
              type='number'
              name='long'
              variant='filled'
              onChange={handleChange}
              value={position.long || ''}
              sx={{ color: BP_COLOR[10] }}
            />
            <Button type='submit'>Inspecter la zone</Button>
          </Stack>
        </Box>
      </Paper>
    </Box>
  );
};
